import { BaseColumnModel } from '~components/dynamic-table/models/column-types/base-column.model';
import { StackedColumnModel } from '~components/dynamic-table/models/column-types/stacked-column.model';
import { StringColumnModel } from '~components/dynamic-table/models/column-types/string-column.model';

export const userSelectionTableConfig: BaseColumnModel[] = [
    new StackedColumnModel({
        propertyName: 'userName',
        propertyName2: 'company',
        columnTitleKey: 'User.List.DisplayName'
    }),
    new StringColumnModel({
        columnTitleKey: 'User.List.Email',
        propertyName: 'email',
        widthPixels: 250
    })
];
